import React, { useEffect, useState } from "react";
import { useSocket } from "../../../context/SocketContext";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/utils/Dispatcher";
import { makeGroupCall } from "../../../redux/slices/sipSlice";
import { storageService } from "../../../services/storageService";
import { RootState } from "../../../redux/store";
import GradientButton from "../../common/UI/GradientButton";
import "./index.scss";
interface GroupCallInviteProps {
  //   userId: string;
}

const GroupCallInvite: React.FC<GroupCallInviteProps> = () => {
  const { socket } = useSocket();
  const dispatch = useAppDispatch();
  const { calls } = useSelector((state: RootState) => state.sip);
  const [showButton, setShowButton] = useState<boolean>(false);
  const userId = storageService.getUserId();
  const { currentChat } = useSelector((state: RootState) => state.chat);
  const [callDetails, setCallDetails] = useState<any>(null);
  const alreadyInCall = Boolean(Object.keys(calls)?.length);

  const joinCall = () => {
    dispatch(
      makeGroupCall({
        groupId: currentChat?.id || "",
        isJoining: true,
      })
    );
  };

  useEffect(() => {
    if (!socket) return;

    socket?.on("groupCall", (message: any) => {
      const data = message.data;
      const user = data.find((member: any) => member.accountId === userId);

      setCallDetails({
        groupId: user?.group,
        groupName: user?.groupName,
      });

      setShowButton(() => {
        if (
          user?.invited &&
          !user?.joined &&
          user.action !== "GROUP_CALL_END"
        ) {
          return true;
        }

        return false;
      });
    });
  }, [socket]);

  if (!showButton || !currentChat || alreadyInCall || callDetails?.groupId !== currentChat?.id)
    return null;

  return (
    <div className="group-call-invite">
      <div>Ongoing group call</div>
      <GradientButton onClick={joinCall}>Join</GradientButton>
    </div>
  );
};

export default GroupCallInvite;
